/**
 * Vanguard Market · valores centralizados de la guía para jugadores.
 * Fuente: Manual-MarketShop-2.11 (edición 14/10/2026; 2.11.0 y diagnóstico 2.11.1).
 * Solo documentación: no es la configuración activa del Market.
 */

/** Aviso temporal: mientras sea false, la guía indica que el Market todavía no puede usarse. */
export const MARKET_AVAILABLE = false

export const MARKET_URL = 'https://market.mu-vanguard.com/'
export const MARKET_BASE_PATH = '/vanguard-market'
export const MARKET_SOURCE_LABEL = 'Documentado en el manual 2.11 · 14/10/2026'
export const SHOT_CAPTION = 'Captura demostrativa del manual 2.11. Los datos mostrados son ficticios.'
export const NO_FEE_TEXT = 'Consulta la comisión actual en la confirmación del Market.'
export const PROGRESS_STORAGE_KEY = 'vanguard.market.progress.v1'

/** Reglas documentadas en el manual 2.11 (no son la configuración vigente confirmada). */
export const documented = {
  creditsPerUsdt: 10,
  usdtStep: '0,10',
  pageSizeCatalog: 24,
  cartMaxLines: 20,
  cartMaxUnits: 100,
  officialLineMax: 99,
  movementsShown: 200,
  rechargesPerPage: 50,
  withdrawMinCredits: 100,
  withdrawMinUsdt: '10,00',
  withdrawEveryHours: 72,
  manualReview: 'de 1 a 24 horas',
  timezone: 'UTC',
}

/** Porcentajes que el manual usa solo como ejemplo. */
export const examplePercents = { sale: '3', withdraw: '5' }

/**
 * Valores configurables sin confirmar para producción. Se muestran solo en la vista del staff.
 * undefined = no confirmado: la guía pide consultarlo en el Market en lugar de inventarlo.
 */
export const configurable: { label: string; value?: string; note: string }[] = [
  { label: 'Nombre visible de la moneda web', note: 'El manual usa CREDITS como ejemplo. No se identifica con Zen, WCoin ni Vanguard Coin sin confirmación.' },
  { label: 'Comisión de venta vigente', note: 'El manual usa 3 % como ejemplo.' },
  { label: 'Comisión de retiro vigente', note: 'El manual usa 5 % como ejemplo.' },
  { label: 'Máximo de publicaciones activas y vigencia en días', note: 'Las capturas muestran 20 y 30 días con datos ficticios.' },
  { label: 'Métodos y redes de recarga habilitados', note: 'Binance ID y redes de billetera dependen de la configuración.' },
  { label: 'Mínimo y máximo de recarga por destino', note: 'La captura muestra 1,00–500,00 USDT con datos ficticios.' },
  { label: 'Entrega al juego habilitada', note: 'Determina si los ítems van al Gremory o quedan en resguardo.' },
  { label: 'Productos oficiales: solo consumibles (VIP, Panda Combo, Skeleton Combo, talismanes, resetear stats, resetear árbol, cambiar raza, cambiar nombre)', note: 'Confirmado por el staff 14/10/2026. Falta el destino exacto y la duración de cada uno.' },
  { label: 'Canal de atención del Market', note: 'La guía enlaza el Discord del servidor ya publicado; falta confirmar si es el canal de atención del Market.' },
  { label: 'Disponibilidad actual del Market', value: 'Aviso temporal: no disponible', note: 'Cambiar MARKET_AVAILABLE cuando el staff lo indique.' },
]

/** Diferencias registradas entre fuentes; no cambian ninguna regla. */
export const sourceNotes: string[] = [
  'La pantalla de publicación (captura 09) conserva un texto heredado que dice que la entrega aún no está habilitada. El manual indica consultar la disponibilidad real en Mis compras → Mis ítems.',
  'Las capturas muestran 3,00 % de comisión de venta, 5,00 % de retiro y 30 días de vigencia: son datos de una demostración local, no tarifas vigentes.',
]
